import { currentDateTime, setCurrentDateTime, TIME_FORMAT} from '@/utils.js';

export const timerControl = {
    controller: function (args) {
    },
    view: function (ctrl) {
        // текст (дата/время) подставляется в runCurrentTimeTimer
        return m("span[id='ts'][style='padding-right:3px;line-height:1.1;']", '');
    }
};

export function runCurrentTimeTimer() {
    setInterval(function () {
        if (currentDateTime) {
            setCurrentDateTime(moment(currentDateTime, TIME_FORMAT).add(1, 's').format(TIME_FORMAT));
            const element = document.getElementById('ts');
            if (element) {
                element.innerHTML = currentDateTime.replace(' ', '<br>');
            }
        }
    }, 1000);
}
